import React from 'react';
import { Drawer, Box, Typography, IconButton, List, ListItem, ListItemText, Badge, Button, useTheme, useMediaQuery } from '@mui/material';
import { Close, Circle } from '@mui/icons-material';
import { getApiUrl } from '../utils/apiConfig';

export default function NotificationsDrawer({ open, onClose, items: initialItems = [] }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [items, setItems] = React.useState(initialItems);
  React.useEffect(() => { setItems(initialItems); }, [initialItems]);

  const refresh = async () => {
    try {
      const token = localStorage.getItem('_at') || localStorage.getItem('token');
      const headers = token ? { Authorization: `Bearer ${token}` } : {};
      const r = await fetch(getApiUrl('/api/notifications'), { headers });
      const j = await r.json();
      if (j.success) setItems(j.notifications || j.data || []);
    } catch {}
  };

  const markRead = async (id) => {
    try {
      const token = localStorage.getItem('_at') || localStorage.getItem('token');
      const headers = token ? { Authorization: `Bearer ${token}` } : {};
      await fetch(getApiUrl(`/api/notifications/${id}/read`), { method: 'POST', headers });
      setItems(prev => prev.map(n => n.id === id ? { ...n, read: true } : n));
    } catch {}
  };

  return (
    <Drawer
      anchor={isMobile ? 'bottom' : 'right'}
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          width: isMobile ? '100%' : 360,
          height: isMobile ? '70vh' : '100%',
          borderTopLeftRadius: isMobile ? 16 : 0,
          borderTopRightRadius: isMobile ? 16 : 0,
        },
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', px: 2, py: 1.5 }}>
        <Typography variant="subtitle1">Notifications</Typography>
        <IconButton size="small" onClick={onClose}>
          <Close fontSize="small" />
        </IconButton>
      </Box>
      <Box sx={{ px: 2, pb: 1 }}>
        <Button size="small" onClick={refresh}>Refresh</Button>
      </Box>
      <List dense>
        {items.length === 0 && (
          <ListItem><ListItemText primary="No notifications" secondary="You're up to date" /></ListItem>
        )}
        {items.map((n, i) => (
          <ListItem key={i} alignItems="flex-start">
            <ListItemText
              primary={n.title}
              secondary={n.created_at ? new Date(n.created_at).toLocaleString() : n.time}
              onClick={() => markRead(n.id)}
            />
            {!n.read && <Badge color="primary" variant="dot"><Circle sx={{ fontSize: 8, color: 'transparent' }} /></Badge>}
          </ListItem>
        ))}
      </List>
    </Drawer>
  );
}
